import { Xmark } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { SpuIdsEditor } from "../SpuIdsEditor";

interface ProductSamplesContentProps {
  isModal?: boolean;
  onClose: () => void;
}

export const ProductSamplesContent = ({
  isModal,
  onClose,
}: ProductSamplesContentProps) => {
  const { isMobile } = useGravityDevice();

  return (
    <Flex
      direction="column"
      gap={4}
      style={{
        padding: 20,
        minWidth: isMobile ? 0 : 800,
        maxWidth: 800,
        width: "100%",
      }}
    >
      <Flex justifyContent={"space-between"}>
        <Text variant="subheader-3">Просмотр выборки</Text>
        {isModal && (
          <Button view="flat" onClick={onClose}>
            <Icon data={Xmark} />
          </Button>
        )}
      </Flex>

      <Flex direction={"column"} gap={4} width={"100%"}>
        <SpuIdsEditor />
      </Flex>
    </Flex>
  );
};
